import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { ValidationService } from '../validation.service';
import {MatDialog,MatDialogRef,MAT_DIALOG_DATA,} from "@angular/material/dialog";
import {MatPaginator,PageEvent, MatTableDataSource, MatSort, Sort, MatAutocompleteTrigger } from '@angular/material';
import { TimeService } from '../time.service';
import { trigger, state, transition, style, animate } from '@angular/animations';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { element } from 'protractor';
import { DateTime } from 'luxon';
import { LoadDashboardAcceptModalComponent } from '../dashboardModals/load-dashboard-accept-modal/load-dashboard-accept-modal.component';
import { AssignLoadComponent } from '../assign-load/assign-load.component';
import { Subscription } from 'rxjs';
import { EventService } from '../event.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-load-dashboard',
  templateUrl: './load-dashboard.component.html',
  styleUrls: ['./load-dashboard.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('300ms ease-in', style({ transform: 'translateX(0%)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0.6 }),
        animate('200ms ease-in', style({ opacity: 0.6 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0.6 }))
      ])
    ]),

  ],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
  }]
})
export class LoadDashboardComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  displayedColumns: string[] = [
    "load",
    // "material",
    "customer", 
    "allocated",
    "accepted",
    "assigned",
    "plantDate",
    "created_at",
    "shipper",
  ];
  allocationColumns: string[] = ['slno', 'requested', 'accepted', 'cancelled', 'deadline', 'assigned', 'action'];
  dataSource = new MatTableDataSource<Element>();
  showLoader = false;
  ordersArray: any = [];
  orders: any = [];
  Organisations: any[];
  showStatusTab = 0;
  showOrderDetailsView = 0;
  allocationDataSource: any;
  allocTable: any;
  selectedOrderData: any;
  allocationArray=[];
  created_date ='';
  carrierId: Subscription;
  totalOrders=0;
  loadsFilter: any = {
    limit: 0,
    skip: 0,
  };
  accepted_plan: any;
  constructor( private http: HttpService,public timeService: TimeService,private events: EventService,private snackBar: SnackbarService, private time: TimeService,private valid: ValidationService,private dialog: MatDialog, private router: Router) { }

  ngOnInit() {
    
    this.getOrders()
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getOrders()
      },
      (err: any) => {
        console.log('Err ::', err);
      }
    );
  }

  getOrders(filters: any = {}) {
    filters.limit = this.paginator.pageSize || 25;
    filters.skip = this.paginator.pageIndex * (this.paginator.pageSize || filters.limit);
    this.http.get("loads",filters).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.ordersArray = data.data.loads;
          this.totalOrders = data.data.count;
          this.orders = [];

          this.ordersArray.forEach((element) => {

            const temp: any = {};
            temp._id = element._id;
            temp.load = element.load.LIN;
            temp.load_id = element.load._id;
            temp.created = (element.load.created_at) ? this.timeService.utcToist(element.load.created_at, 'dd-MMM-yy HH:mm a') : '--'
            temp.plan_date = (element.load.plan_date) ? this.timeService.utcToist(element.load.plan_date, 'dd-MMM-yy HH:mm a') : '--'
            temp.total_weight = element.total_weight;
            temp.materials=element.load.materials[0].name;
            temp.materials_id=element.load.materials[0]._id;
            temp.shipper=element.shipper;            
            temp.state = element.load.state.name;
            temp.allocated = element.allocated;
            temp.accepted = element.accepted;
            temp.assigned = element.assigned;
            temp.available_plan = element.load ? element.load.available_plan: [];
            temp.accepted_plan = element.accepted_plan;
            temp.customer = element.load ? element.load.customer : [];
            temp.assignmentDeadline= (element.assignment_deadline) ? this.timeService.toShortDateMonthTime(element.assignment_deadline) : '',
            temp.acceptanceDeadline= (element.acceptance_deadline) ? this.timeService.toShortDateMonthTime(element.acceptance_deadline) : '',
            temp.assignment_deadline= (element.assignment_deadline);
            temp.acceptance_deadline= (element.acceptance_deadline);
            temp.cancelled = element.cancelled;
            temp.fulfilled = element.fulfilled;
            temp.vehicle_no = element.do_issued && element.do_issued.length > 0 ? element.do_issued[0].vehicle_no : '';
            temp.shipperId = ( element.load && element.load.shipper && element.load.shipper._id ) ? element.load.shipper._id : '';
            this.orders.push(temp);
          });
          
          this.showLoader = false;
          if (!this.dataSource) {
            this.dataSource = new MatTableDataSource(this.orders);            
          } else {
            this.dataSource = new MatTableDataSource(this.orders);            
          }
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, "", "err");
        // this.paginator._intl.itemsPerPageLabel = this.translation.instant(
        //   "DASHBOARD.pagination_label"
        // );
        if (err.error.statusCode == 401) {
         // this.valid.logout();
        }
      }
    );
  }
  formatTime(time) {
    return this.time.toShortDateTime(time, 'dd-MMM-yyyy');
  }
  acceptLoad (element){
    this.accepted_plan = element.customer.map(c => c.name).join(', ');
    this.accepted_plan = [{ name: this.accepted_plan, weight: element.allocated}];
    let data = {
      load_allocation_id: element._id,
      accepted_load:element.allocated,
      accepted_plan: this.accepted_plan,
    }

    this.http.post('v2/loads/accept', data).subscribe(
      (data: any) => {

        if (data.statusCode === 200) {
          this.snackBar.openSnackBar('Load Accepted Successfully', '');
          this.showStatusTab=0;
          this.getOrders();
        }

      },
      (err: any) => {

        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  openAssignSideModal2(element) {
   

      const now: any = DateTime.local();
      const deadline: any = this.timeService.IsoToUTC(element.assignment_deadline);
      const deadlineAcc: any = this.timeService.IsoToUTC(element.acceptance_deadline);
      this.allocationArray=[];

      const temp: any = {    

        slno:  1,
        accepted: element.accepted,
        assignmentDeadline: (element.assignment_deadline) ? this.timeService.toShortDateMonthTime(element.assignment_deadline) : '',
        acceptanceDeadline: (element.acceptance_deadline) ? this.timeService.toShortDateMonthTime(element.acceptance_deadline) : '',
        disableAssign: (element.assignment_deadline) ? ((deadline.ts > now.ts) ? true : false) : false,
        disableAccept: (element.acceptance_deadline) ? (deadlineAcc.ts > now.ts) ? true : false : false,
        disableAcceptBtn: (element.allocated != element.cancelled),
        assigned: element.assigned,
        cancelled: element.cancelled,
        //cancelled_after_acceptance: element.cancelled_after_acceptance,
        //cancelled_before_acceptance: element.cancelled_before_acceptance,
        to_be_assigned: element.accepted - (element.assigned + element.cancelled),
        //assign_number: (element.accepted - element.cancelled_after_acceptance - element.assigned),
        assign_number: (element.accepted -  element.assigned),
        // rejected: element.rejected,
        // rate: element.rate,
        // rate_per_weight: element.rate_per_weight ? element.rate_per_weight : 0,
        // rate_per_pallet: element.rate_per_pallet ? element.rate_per_pallet : 0,

        // offered_price: element.rate_per_weight ? element.rate_per_weight : element.rate_per_pallet ? element.rate_per_pallet : element.rate,
        // rate_type: element.rate_type,
        allocated: element.allocated,
       // uom: element.order.uom,
        //disable_btns: (element.accepted == 0 && element.rejected > 0) ? true : false, // if accepted = 0 and rejected > 0 show the action as rejected
        _id: element._id,
       // carrier: element.carrier,
       // OIN: element.order.OIN,
        //allocation_type: element.allocation_type
      }

      this.allocationArray.push(temp);

      // this.allocationArray = new MatTableDataSource(this.orders);

    //});



        //const now: any = DateTime.local();
        //const deadline: any = this.timeService.IsoToUTC(element.assignmentDeadline);
       // const deadlineAcc: any = this.timeService.IsoToUTC(element.acceptanceDeadline);
       // const deadlineAcc: any = this.timeService.IsoToUTC(element.acceptanceDeadline);
    
    
        //element.disableAccept= (element.acceptanceDeadline) ? (deadlineAcc.ts > now.ts) ? true : false : false;
    
    
    
       this.created_date=element.created;
    
    
        this.showStatusTab = 1;
        this.showOrderDetailsView = 0;
        this.selectedOrderData = element;
    
        // this.allocationArray=[];
        // this.allocationArray.push(element)
    
        if (this.allocTable) {
          this.allocTable.renderRows();
        }
       
    
      }
  openAssignSideModal(element) {

    let now = DateTime.local();
    let deadline: any = this.timeService.IsoToUTC(element.assignment_deadline);
    let deadlineAcc = this.timeService.IsoToUTC(element.acceptance_deadline);

   
    if(element.accepted >0){
      element.disableAccept=false;
    }else {
      element.disableAccept= (element.acceptance_deadline) ? (deadlineAcc.ts > now.ts) ? true : false : false;
    }
   this.created_date=element.created;

    this.showStatusTab = 1;
    this.showOrderDetailsView = 0;
    this.selectedOrderData = element;

    this.allocationArray=[];
    this.allocationArray.push(element)

    if (this.allocTable) {
      this.allocTable.renderRows();
    }
   

  }

  openAcceptModal(data,type) {
    if (!data.accepted) {
     // data.to_be_accepted = data.allocated - data.cancelled_before_acceptance;
    } else {
     // data.to_be_accepted = data.allocated - data.cancelled_after_acceptance;
    }
    data.to_be_accepted = data.allocated ;

    const parentdata: any = {
      allocation_id: data._id,
      allocated: data.allocated,
      cancelled: data.cancelled,
      to_be_accepted: data.to_be_accepted,
      rate: data.rate,    
      order: this.selectedOrderData,      
      allocation_type: data.allocation_type,
      type: type,
      available_plan:data.available_plan,
      accepted_plan: data.accepted_plan,
      customer: data.customer
    };
    
    data.rate_per_pallet = 0
    const dialogRef = this.dialog.open(LoadDashboardAcceptModalComponent, {
      data: parentdata
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.statusCode == 200) {
        this.getOrders();
        this.showStatusTab = 0;
       // this.openAssignSideModal(this.selectedOrderData);
      }
    });
  }
  pageNavigate(event: PageEvent) {
    this.loadsFilter.limit = event.pageSize;
    this.loadsFilter.skip = event.pageIndex * event.pageSize;
    this.getOrders();
  }

  openAssignModal(data) {
    console.log(data, "data");
    const loadData = {
      is_cement: data.shipperId === "66cb78e108583b1fa294d901" ? true : false,
      shipperId: data.shipperId,
      quantity: data.accepted ? data.accepted : 0,
      load_id: data._id ? data.load_id : '',
      LIN: data.load ? data.load : '', 
      customer_name: data.customer && data.customer.length > 0 ? data.customer[0].name : '',
      customer_location: data.customer && data.customer.length > 0 ? `${data.customer[0].city} - ${data.customer[0].locality}` : '',
      materials_id: data.materials_id ? data.materials_id : '',
      materials: data.materials ? data.materials : '',
    };
    this.router.navigate(['loadDashboard/assign'], {
      state: { loadData: loadData }
    });
  }

  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }
}
